import React, { FC, PropsWithChildren } from 'react';

import styles from 'bloko/blocks/drop/Down/down.less';

const NoPaddings: FC<PropsWithChildren> = (props: React.ComponentPropsWithoutRef<'div'>) => {
    return <div {...props} className={styles['bloko-drop-down-no-paddings']} />;
};

export default NoPaddings;
